import { useState, useRef } from "react";
import { MarsGlobe } from "@/components/MarsGlobe";
import { SectorPanel } from "@/components/SectorPanel";
import { formatCoord } from "@/lib/sectors";
import { useLang } from "@/context/LanguageContext";

export default function ExploreMars() {
  const { t } = useLang();
  const [selected, setSelected] = useState(null);
  const [marker, setMarker] = useState(null);
  const [hover, setHover] = useState(null);
  const hoverRef = useRef("");

  const handlePick = (s) => {
    setSelected(s);
    setMarker({ lat: s.lat, lng: s.lng });
  };

  const handleHover = (s, pos) => {
    if (!s) { setHover(null); hoverRef.current = ""; return; }
    hoverRef.current = s.sectorId;
    setHover({ ...s, x: pos?.x, y: pos?.y });
  };

  return (
    <div className="relative h-screen w-full overflow-hidden">
      <div className="absolute top-20 left-5 md:left-8 z-30 pointer-events-none">
        <div className="text-overline">{t.explore.console}</div>
        <h1 className="font-display text-2xl md:text-3xl tracking-wide mt-2">{t.explore.title}</h1>
        <p className="text-cosmic/60 text-xs md:text-sm font-mono mt-2 max-w-xs">
          {t.explore.hint}
        </p>
      </div>

      <div className="absolute bottom-6 left-5 md:left-8 z-30 glass border border-cosmic/10 px-4 py-3 pointer-events-none">
        <div className="text-overline mb-1">{t.explore.live}</div>
        <div className="font-mono text-sm text-portal" data-testid="live-coordinate">
          {hover ? formatCoord(hover.lat, hover.lng) : "— —"}
        </div>
        <div className="font-mono text-[0.7rem] text-cosmic/60 mt-1">
          {hover ? hover.sectorId : t.explore.standby}
        </div>
      </div>

      <div className="absolute inset-0 z-10">
        <MarsGlobe onPick={handlePick} onHover={handleHover} interactive marker={marker} />
      </div>

      {hover && hover.x != null && (
        <div
          className="fixed z-40 pointer-events-none glass border border-portal/40 px-3 py-2"
          style={{ left: hover.x + 14, top: hover.y + 14 }}
        >
          <div className="font-mono text-xs text-portal">{hover.sectorId}</div>
          <div className="font-mono text-[0.65rem] text-cosmic/70">{formatCoord(hover.lat, hover.lng)}</div>
        </div>
      )}

      {selected && (
        <SectorPanel
          sectorId={selected.sectorId}
          onClose={() => { setSelected(null); setMarker(null); }}
          onRegistered={() => {}}
        />
      )}
    </div>
  );
}
